import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';
import ProcessExtractResult from '@pages/candidate/userinput/ProcessExtractResult';
import {cloneDeep} from 'lodash';
import {requestCandidates} from "@app/services/CandidateService";
import {
    CommonUseFields,
    CONTACT_NEED_APPROVE_FIELDS,
    DEFAULT_PAGE_SIZE, LOCAL_STORAGE_USER_LOGIN_INFO,
    MergeType,
    NotifyStatus, NotifyType, ONLY_ONE_VALUE_NEED_APPROVE_FIELDS,
    ResponseCode, USER_INPUT_IN_PRIORITY_TIME_RANGE_FIELDS
} from "@app/constants/Common";
import {requestSaveCandidateGroup} from "@app/services/CandidateGroupService";
import {requestApproveNotify, requestRejectNotify, requestUpdateNotifyStatus} from "@app/services/UserService";
import {compareArrays, stringToArray} from "@app/utils/CommonUtils";
import NotificationStatus from "@pages/notification/NotificationStatus";

const NotificationEditModal = (props) => {
    const [notify, setNotify] = useState({
        feedback_note: ""
    });
    const [needApproveFields, setNeedApproveFields] = useState([]);
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [dataChange, setDataChange] = useState({
    });

    const [isLoading, setIsLoading] = useState(false)

    const {isShow} = props
    const {notification} = props
    const {onClose} = props

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])

    useEffect(() => {
        let dataNotify = cloneDeep(notification)
        dataNotify.objectOrigin = dataNotify.object_origin ? JSON.parse(dataNotify.object_origin): {}
        dataNotify.objectChange = dataNotify.object_change ? JSON.parse(dataNotify.object_change): {}
        setNotify(dataNotify)
        if (dataNotify.type === NotifyType.UPDATE_CONTACTS) {
            setNeedApproveFields(CONTACT_NEED_APPROVE_FIELDS)
        } else if (dataNotify.type === NotifyType.REPORT_WRONG_INPUT) {
            const needApproveFieldList = Object.keys(CommonUseFields).map(item => {
                return {key: item, label: CommonUseFields[item].title}
            })
            setNeedApproveFields(needApproveFieldList)
        } else if (dataNotify.type === NotifyType.DIFF_OTHER_INPUT_ONE_VALUE_FIELD) {
            setNeedApproveFields(ONLY_ONE_VALUE_NEED_APPROVE_FIELDS)
        } else if (dataNotify.type === NotifyType.USER_INPUT_IN_PRIORITY_TIME_RANGE) {
            setNeedApproveFields(USER_INPUT_IN_PRIORITY_TIME_RANGE_FIELDS)
        }
    }, [notification]);

    const onChangeNotify = (event) => {
        notify[event.target.name] = event.target.value
        setNotify({...notify})
    }

    const onApproveNotify = () => {
        notify.data_change = dataChange
        setIsLoading(true)
        requestApproveNotify(notify).then((res) => {
            onClose(res.sts_code===ResponseCode.SUCCESS, true)
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const onRejectNotify = () => {
        notify.data_change = dataChange
        setIsLoading(true)
        requestRejectNotify(notify).then((res) => {
            onClose(res.sts_code===ResponseCode.SUCCESS, true)
        }).catch((error) => {
            console.log(`Error:${JSON.stringify(error)}`);
        }).finally(() => {
            setIsLoading(false);
        });
    }

    const feedbackNotesValue = () => {
        if (notify.feedback_note) {
            return notify.feedback_note
        }
        if (userLoginInfo.is_superuser && notify.type === NotifyType.REPORT_WRONG_INPUT) {
            return "Ad đã xem report"
        }
        return ""
    }

    return (
        <>
            <Modal show={isShow}
                   size={'lg'}
                   onHide={onClose}
                   animation={false}>
                <Modal.Header>
                    <Modal.Title>Chi tiết thông báo: {notify.title}</Modal.Title>
                    {notify.type !== NotifyType.BOOKING_REJECTED_INFORM &&
                    <NotificationStatus value={notify.status}/>
                    }
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    {notify.type !== NotifyType.BOOKING_REJECTED_INFORM &&
                    <div className={"w-100"}>
                        <label>Người gửi: {notify.send_user_name}</label>
                    </div>
                    }

                    {notify.type !== NotifyType.BOOKING_REJECTED_INFORM &&
                    <div className={"w-100"}>
                        <label>Ngày tạo: {notify.created_date_time}</label>
                    </div>
                    }
                    <div>
                        <label>Person: </label>
                        <a href={`/candidate/detail/${notify.candidate_id}`} target="_blank"
                           rel="noreferrer"
                           className={'text-primary font-weight-bold'}> {notify.candidate_id}</a>
                    </div>
                    {notify.type === NotifyType.BOOKING_REJECTED_INFORM && notify.objectOrigin.pipeline_id &&
                    <>
                        <div>
                            <label>Pipeline: </label>
                            <a href={`/job/pipeline/list?id=${notify.objectOrigin.pipeline_id}`} target="_blank"
                               rel="noreferrer"
                               className={'text-primary font-weight-bold'}> {notify.objectOrigin.pipeline_id}</a>
                        </div>
                        {/*<div>*/}
                        {/*    <label>Book time: </label>*/}
                        {/*    {notify.objectOrigin.created_booked_date_time ? notify.objectOrigin.created_booked_date_time : ""}*/}
                        {/*</div>*/}
                        {/*<div>*/}
                        {/*    <label>Reject time:  </label>*/}
                        {/*    {notify.created_date_time}*/}
                        {/*</div>*/}
                    </>
                    }
                    {notify.type !== NotifyType.BOOKING_REJECTED_INFORM && notify.type !== NotifyType.USER_BLOCK_UV &&
                    <div>
                        <label>Danh sách các trường thay đổi </label>
                        <table
                            className='table table-hover table-bordered'
                        >
                            <thead>
                            <tr>
                                <th>No.</th>
                                <th>Tên trường</th>
                                {notify.type !== NotifyType.USER_INPUT_IN_PRIORITY_TIME_RANGE &&
                                <th>Giá trị cũ</th>
                                }
                                <th>{notify.type !== NotifyType.USER_INPUT_IN_PRIORITY_TIME_RANGE ? "Giá trị mới" : "Thông tin NL"}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {notify.objectOrigin && needApproveFields.map((field, index) => {
                                let oldValues = stringToArray(notify.objectOrigin[field.key]).sort()
                                let newValues = stringToArray(notify.objectChange[field.key]).sort()
                                let isEqual = compareArrays(oldValues, newValues)
                                if (!isEqual) {
                                    dataChange[field.key] = newValues
                                }
                                return !isEqual && <tr key={`old_new_item_${index}`}>
                                    <td>{index + 1}</td>
                                    <td>{field.label}</td>
                                    {notify.type !== NotifyType.USER_INPUT_IN_PRIORITY_TIME_RANGE &&
                                    <td>
                                        {oldValues.map(ov => (
                                            <tr>{ov}</tr>
                                        ))}
                                    </td>}
                                    <td>
                                        {newValues.map(nv => (
                                            <tr>{nv}</tr>
                                        ))}
                                    </td>
                                </tr>
                            })}
                            </tbody>
                        </table>
                    </div>}
                    {notify.type !== NotifyType.BOOKING_REJECTED_INFORM &&
                    <div>
                        <label className={'w-100'}>{"Người gửi Notes"}</label>
                        <div style={{overflowWrap: 'break-word'}}>{notify.sender_note}</div>
                    </div>}
                    {notify.type !== NotifyType.BOOKING_REJECTED_INFORM &&
                    <div className='input-group mt-3'>
                        <label className={'w-100'}>Feedback Notes</label>
                        <textarea className='form-control'
                               disabled={notify.status !== NotifyStatus.WAITING || !userLoginInfo.is_superuser}
                               value={feedbackNotesValue()}
                               name={'feedback_note'} onChange={event => onChangeNotify(event)}/>
                    </div>}
                </Modal.Body>
                {notify.type !== NotifyType.BOOKING_REJECTED_INFORM && notify.status === NotifyStatus.WAITING && userLoginInfo.is_superuser &&
                <Modal.Footer>
                    <Button type='button'
                            className='btn btn-danger'
                            isLoading={isLoading}
                            disabled={
                                isLoading
                            }
                            onClick={() => {
                                onRejectNotify()
                            }}
                            >
                        Từ chối
                    </Button>
                    <Button type='button'
                            className='btn btn-primary'
                            isLoading={isLoading}
                            disabled={
                                isLoading
                            }
                            onClick={() => {
                                onApproveNotify()
                            }}
                            >
                        OK
                    </Button>
                </Modal.Footer>
                }
            </Modal>
        </>
    )
}

export default NotificationEditModal;
